// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  azureAd: {
    clientId: 'a5967050-8526-447c-890f-1c313c446f8f',
    tenantId: '842a3284-a7e3-49fc-b7b3-f7274abc7207',
    clientSecret: '~-E8Q~jeouCO9LvppOViV~Qehz~qR2Cq1scr~bRY' // Solo necesario para client credentials flow
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
